import { useLocation, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";

const Layout = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  useEffect(() => {
    let _UserSession = localStorage.getItem("vs_UserSession");
    if (_UserSession !== undefined && _UserSession !== null) {
      _UserSession = JSON.parse(_UserSession);
      setSubscriptionStatus(_UserSession.subscriptionStatus === "active");
    }
  }, []);

  useEffect(() => {

    if(subscriptionStatus === null) return;
    if(!location?.pathname) return;

    if (
        !subscriptionStatus &&
        (
          location.pathname.startsWith("/business/add-sale") ||
          location.pathname.startsWith("/business/add-purchase") ||
          location.pathname.startsWith("/business/create-other-income") ||
          location.pathname.startsWith("/business/add-expense")
        )
      ) {
        history.push("/business/choosePlan");
      }
  }, [location?.pathname, subscriptionStatus, history]);

  return (
    <div>
      <main>{children}</main>
    </div>
  );
};

export default Layout;